import { render, staticRenderFns } from "./DocumentsBlock.vue?vue&type=template&id=e58e550c&scoped=true"
import script from "./DocumentsBlock.vue?vue&type=script&lang=js"
export * from "./DocumentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58e550c",
  null
  
)

export default component.exports